import * as React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom'
import { IheaderComponentProps } from "./IheaderComponentProps";
import { IheaderComponentState } from "./IheaderComponentState";


import 'src/assets/css/main.css';
import 'src/assets/css/reset.css';
import 'src/assets/css/fonts.css';
import 'src/assets/css/modal.css';

import loop from 'src/assets/images/loop.png'
import man from 'src/assets/images/man.png'
import LoginModal from "../loginModal";
import MenuLeftComponent from "../menuLeftComponent/MenuLeftComponent";
import Popup from "reactjs-popup";
import MagicDropzone from "react-magic-dropzone";
import UploadGifComponent from "../uploadGifComponent/UploadGifComponent";
import CreateGifModalComponent from "../createGifModalComponent/CreateGifModalComponent";
import { ILoginModalProps } from "../loginModal/ILoginModalProps";
import ToastComponent from '../toastComponent';

import * as actions from "../../actions/gifAction";
import * as modalActions from "../../actions/modalActions";



class HeaderComponent extends React.Component<IheaderComponentProps, IheaderComponentState> {


    constructor(props: IheaderComponentProps) {
        super(props)

        // Default state
        this.state = {
            searchText: ''
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.setState({
            searchText: this.props.searchText instanceof Array ? '' : this.props.searchText
        })
    }

    handleChange(event) {
        this.setState({ searchText: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.handleSearch(this.state.searchText, () => {
            this.props.history.push({ pathname: '/search', })
        })
    }
    public render() {
        const isLoggedIn = this.props.authenticated;
        return (
            <div className='_topHeader'>
                <ToastComponent />
                <header className='container'>
                    <div className='search _ctn'>
                        <div className='icon'>
                            <img src={loop} alt="" />
                        </div>
                        <form onSubmit={this.handleSubmit}>
                            <input type="text" name="" value={this.state.searchText ? this.state.searchText : ''} onChange={this.handleChange}
                                placeholder="Recherche" />
                        </form>

                    </div>
                    <div className='buttons _ctn'>
                        {/*<Link className='create _btn' to="/creategif"><span>CREATE</span></Link>*/}
                        <CreateGifModalComponent />
                        <Link className='upload _btn' to="/uploadgif"><span>IMPORTER</span></Link>
                    </div>
                    <div className='profile _ctn'>
                        {!isLoggedIn ?
                            <div className='icon' style={{
                                top: '5px',
                                left: '26px',
                                height: 40,
                                width: 40
                            }}>
                                {isLoggedIn ? <MenuLeftComponent history={this.props.history} /> :

                                    <div style={{
                                        width: '347%',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-around',
                                        color: 'white'

                                    }}>
                                        <div style={{
                                            width:' 40px',
                                            marginTop: '7px'
                                        }}>
                                        <LoginModal />
                                        </div>
                                        <h3
                                            onClick={()=>{
                                                this.props.openLoginModal(!this.props.modalLogin , ()=>{
                                                    console.log('modal Colse')
                                                })
                                            }}
                                            style={{marginTop: 'inherit', marginLeft: '-35px' ,
                                                cursor: 'pointer'
                                            }}>Login</h3>
                                    </div>
                                    }

                            </div> :
                            <div className='icon'>
                                {isLoggedIn ? <MenuLeftComponent history={this.props.history} /> :


                                    <div style={{
                                        width: '347%',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-around',
                                        color: 'white'

                                    }}>
                                        <div style={{
                                            width:' 40px',
                                            marginTop: '7px'
                                        }}>
                                            <LoginModal />
                                        </div>
                                        <h3 style={{marginTop: 'inherit', marginLeft: '-35px'}}>Login</h3>
                                    </div>
                                }

                            </div>
                        }
                    </div>
                </header>
            </div>
        );
    }

}


function mapsStateToProps(state) {
    return {
        errorMessage: state.auth.errorMessage,
        authenticated: state.auth.authenticated,
        user: state.auth.currentUser,
        searchText: state.Gif.searchText,
        modalLogin: state.modal.loginModal

    }
}

const mapDispatchToProps = (dispatch: any, ownProps: IheaderComponentProps) => {
    return {
        handleSearch: (text, cb) => dispatch(actions.search(text, cb)),
        openLoginModal: (type , cb) => dispatch(modalActions.loginModal(type, cb))
    }
}

export default connect(mapsStateToProps, mapDispatchToProps)(withRouter(HeaderComponent))



// WEBPACK FOOTER //
// ./src/components/homeHeader/HeaderComponent.tsx